/******** PALETTE OF COLORS ********/

// White
export const white = '#ffffff';

// Black
export const black = '#000';

// Blues
export const darkMediumBlue = '#56808e';
export const darkBlue = '#0f3e4d';
export const darkGreenBlue = '#00222d';
export const lightBlue = '#ebf2fa';
export const mediumLightBlue = '#92adcc';
export const mediumBlue = '#3493e7';
export const lightdarkBlue = '#d7dfe9';
export const lightLightBlue = '#f7fafd';
export const mediumTurquoise = '#5bc0de';

// Greens
export const darkGreen = '#4e7d10';
export const mediumGreen = '#8fce3d';
export const mediumEmerald = '#20c682';
export const lightGreen = '#D1E3BA';

// Grey
export const darkerGrey = '#222';
export const darkMediumGrey = '#506f78';
export const lightGrey = '#d7dee9';
export const mediumGrey = '#bbcadd';

// Reds
export const lightRed = '#ef6474';
export const mediumRed = '#e6112b';

// Yellows
export const lightYellow = '#ffdb6c';
export const mediumYellow = '#ffce38';

// Pinks
export const mediumPink = '#cc0a56';
export const lightPink = '#C5C5FE';
export const errorColor = '#e7112a';

// Snackbar
export const variantSuccess = '#0f0';
export const variantError = '#d32f2f';
export const variantInfo = '#2979ff';
export const variantWarning = '#ffa000';

// New colors
export const lightPrimary = '#0505F0';
export const lightSecondary = '#ffffff';
export const lightInfo = '#ceedf5';
export const lightSuccess = '#cef4d8';
export const lightWarning = '#f4edce';
export const lightDanger = '#fbc7ce';

export const primaryColor = '#4b4bfb';
export const secondaryColor = '#e0e0f4';
export const infoColor = '#79ddf6';
export const successColor = '#73fc98';
export const warningColor = '#f6dd79';
export const dangerColor = '#d7707e';
export const secondaryHover = '#f5f5ff';
export const secondaryLineHover = '#0304A0';

export const mediumPrimary = '#0304a0';
export const mediumSecondary = '#71717a';
export const mediumInfo = '#0c9bc0';
export const mediumSuccess = '#04c839';
export const mediumWarning = '#c09b0c';
export const mediumDanger = '#c00c24';

export const darkPrimary = '#020250';
export const darkSecondary = '#131314';
export const darkInfo = '#053e4d';
export const darkSuccess = '#054d18';
export const darkWarning = '#4d3e05';
export const darkDanger = '#4d050e';
export const linkHover = '#020278';

export const textInputColor = '#4B4B52';
export const brandPrimaryLight = '#a6a6f4';
export const brandPrimary = '#9d9dfd';
export const brandPrimaryDark = '#5858FA';
export const brandPrimaryExtraDark = '#0a0af4';
export const brandPrimaryMaxDark = '#030352';
export const rowBackground = '#FAFAFF';
export const brandPrimaryAlternative = '#7F7FF4';
export const brandPrimaryDarkAlternative = '#0707A3';
